(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-cooking-walkthrough]:not([data-ready])').forEach(root => {
      const buttons = [...root.querySelectorAll('[data-cooking-step]')];
      const panels = [...root.querySelectorAll('[data-cooking-panel]')];
      if (buttons.length !== panels.length || !panels.length) return;
      root.dataset.ready = 'true';
      const select = index => {
        buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        panels.forEach((panel, i) => { panel.hidden = i !== index; });
        root.style.setProperty('--cooking-progress', `${index / Math.max(1, panels.length - 1) * 100}%`);
      };
      buttons.forEach((button, index) => button.addEventListener('click', () => select(index)));
      select(0);
    });

    scope.querySelectorAll('[data-faq-finder]:not([data-ready])').forEach(root => {
      const input = root.querySelector('[data-faq-query]');
      const status = root.querySelector('[data-faq-status]');
      const results = root.querySelector('[data-faq-results]');
      const source = root.closest('.j-answers').querySelector('.j-answers__list');
      if (!input || !source || !status || !results) return;
      const groups = [...source.querySelectorAll('.j-answers__item')];
      const normalize = text => text.toLocaleLowerCase('de-DE').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss');
      const entries = [];
      groups.forEach(group => {
        const body = group.querySelector('.j-answers__answer');
        let heading;
        [...body.children].forEach(node => {
          if (/^H[23]$/.test(node.tagName)) {
            heading = {title: node.textContent.trim(), nodes: [], group};
            entries.push(heading);
          } else if (heading) heading.nodes.push(node);
        });
      });
      if (!entries.length) return;
      root.dataset.ready = 'true';
      const filter = () => {
        const query = normalize(input.value.trim());
        results.replaceChildren();
        if (!query) {
          source.hidden = false;
          results.hidden = true;
          status.textContent = `${entries.length} Antworten. Suche nach deiner Frage oder öffne ein Thema.`;
          return;
        }
        const terms = query.split(/\s+/).filter(Boolean);
        const matches = entries.filter(entry => {
          const text = normalize(`${entry.title} ${entry.nodes.map(node => node.textContent).join(' ')}`);
          return terms.every(term => text.includes(term));
        }).sort((a, b) => terms.filter(term => normalize(b.title).includes(term)).length - terms.filter(term => normalize(a.title).includes(term)).length);
        source.hidden = true;
        results.hidden = false;
        matches.forEach(entry => {
          const detail = document.createElement('details');
          detail.className = 'j-faq-result';
          const summary = document.createElement('summary');
          summary.textContent = entry.title;
          const body = document.createElement('div');
          body.className = 'j-faq-result__answer rte';
          entry.nodes.forEach(node => {
            const clone = node.cloneNode(true);
            clone.removeAttribute('id');
            clone.querySelectorAll('[id]').forEach(child => child.removeAttribute('id'));
            body.append(clone);
          });
          detail.append(summary, body);
          results.append(detail);
        });
        status.textContent = matches.length ? `${matches.length} ${matches.length === 1 ? 'passende Antwort' : 'passende Antworten'}.` : 'Keine passende Antwort. Versuche zum Beispiel „Versand“, „einfrieren“ oder „Vakuum“. Du kannst uns auch persönlich fragen.';
      };
      input.addEventListener('input', filter);
      root.querySelector('[data-faq-clear]').addEventListener('click', () => { input.value = ''; filter(); input.focus(); });
      root.querySelectorAll('[data-faq-suggestion]').forEach(button => button.addEventListener('click', () => { input.value = button.dataset.faqSuggestion; filter(); }));
      window.addEventListener('hashchange', () => { if (input.value) { input.value = ''; filter(); } });
      filter();
    });

    scope.querySelectorAll('[data-partner-explorer]:not([data-ready])').forEach(root => {
      const buttons = [...root.querySelectorAll('[data-partner-select]')];
      const cards = [...root.querySelectorAll('[data-partner-card]')];
      if (buttons.length !== cards.length || !cards.length) return;
      root.dataset.ready = 'true';
      const select = id => {
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.partnerSelect === id)));
        cards.forEach(card => { card.hidden = card.dataset.partnerCard !== id; });
        root.querySelectorAll('[data-partner-marker]').forEach(marker => marker.classList.toggle('is-partner-active', marker.dataset.partnerMarker === id));
      };
      buttons.forEach(button => button.addEventListener('click', () => select(button.dataset.partnerSelect)));
      select(buttons[0].dataset.partnerSelect);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
